import React, { useRef, useState, useEffect } from 'react'
import styled from 'styled-components'
import { InView } from 'react-intersection-observer'
import Spacer from '../../lib/spacer'
import FallingKeys from './falling_keys'
import Notification from './notification'
import Player from './player'
import sampleVideo from './video/sample.mp4'
import { useMediaQuery } from 'react-responsive'
import ReadMoreButton from '../../common/read_more_button'
import { useIsHydrated } from '../../util/ssr'
import { useTranslation } from '../../lib/i18n'

const Wrapper = styled.div`
    overflow: hidden;
    background-color: ${(props) => props.theme.palette.greyScale.lightestGrey};
    border-top: 1px solid ${(props) => props.theme.palette.greyScale.lighterGrey};
    border-bottom: 1px solid ${(props) => props.theme.palette.greyScale.lighterGrey};
`

const AnimationsCell = styled.div`
    position: relative;
`

export default () => {
    const notificationEl = useRef()
    const [showVideo, setShowVideo] = useState(false)
    const [hasScrolled, setHasScrolled] = useState(false)
    const isHydrated = useIsHydrated()
    const { t } = useTranslation(undefined, { keyPrefix: 'home.workSmarter' })
    const mediaIsLarge = useMediaQuery({ minWidth: 950 })
    const isLarge = isHydrated && mediaIsLarge

    useEffect(() => {
        if (typeof window === 'undefined') return
        
        const onScroll = (e) => setHasScrolled(true)

        window.addEventListener('scroll', onScroll)
        return () => window.removeEventListener('scroll', onScroll)
    }, [])

    return (
        <Wrapper>
            <Player url={sampleVideo} show={showVideo} onClose={() => setShowVideo(false)} />
            <Spacer size={150} className="show-for-large" />
            <Spacer size={100} className="show-for-medium-only" />
            <Spacer size={50} className="show-for-small-only" />
            <div className="grid-container">
                <InView
                    disabled={!hasScrolled}
                    threshold={[isLarge ? 1 : 0.4]}
                    onChange={(inView) => inView && notificationEl.current.animate()}
                >
                    <div className="grid-x">
                        <div className="cell large-6 medium-12 text-center large-text-left">
                            <h2 className="h1">
                                {t('titleLine1')}
                                <br />
                                {t('titleLine2')}
                            </h2>
                            <Spacer size={30} />
                            <div className="grid-x medium-align-center large-align-left">
                                <div className="cell medium-8 large-10">
                                    <p>{t('p1')}</p>
                                    <p>{t('p2')}</p>
                                    <p>{t('p3')}</p>
                                </div>
                            </div>
                        </div>
                        <Spacer size={120} className="show-for-medium-only" />
                        <Spacer size={70} className="show-for-small-only" />
                        <AnimationsCell className="cell large-6 medium-12">
                            <div className="grid-x small-align-center large-align-center">
                                <FallingKeys />
                                <Notification
                                    onClick={() => setShowVideo(true)}
                                    ref={notificationEl}
                                />
                            </div>
                        </AnimationsCell>
                    </div>
                </InView>
            </div>
            <Spacer size={100} className="show-for-large" />
            <Spacer size={100} className="show-for-medium-only" />
            <Spacer size={70} className="show-for-small-only" />
        </Wrapper>
    )
}
